<template>
    <div class="card">
        <div class="card-header">
            <!-- BOM titel -->
            <strong>
                <span>{{ $t('s4_title_bom') }}</span>
            </strong>
        </div>

        <div v-if="savedConfig && savedConfig.BOM" class="card-body">
            <!-- TABLE DESKTOP -->
            <div>
                <table class="d-none d-lg-table" width="100%">
                    <thead>
                        <tr style="border-bottom: 1px solid #ccc">
                            <th class="text-center">{{ $t('s4_bom_ref') }}</th>
                            <th class="text-center">{{ $t('s4_bom_description') }}</th>
                            <th class="text-center">{{ $t('s4_bom_quantity') }}</th>
                            <th v-show="savedConfig.priceList.show_prices == 1" class="text-center">{{ $t('s4_bom_price') }}</th>
                            <th v-show="savedConfig.priceList.show_prices == 1" class="text-center">{{ $t('s4_bom_subtotal') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(product,i) in savedConfig.BOM.products"
                            :key="'bom_' + product.id"
                            style="border-bottom: 1px solid #ccc"
                        >
                            <td class="text-left">{{product.id}}</td>
                            <td class="text-left">{{product.name}}</td>
                            <td class="text-right">
                                {{ product.quantity | currency({
                                    symbol: "",
                                    fractionCount: 0
                                })}} {{product.unit_type}}
                            </td>
                            <td v-show="savedConfig.priceList.show_prices == 1" class="text-right">
                                {{product.price_unit | currency({
                                symbol: savedConfig.priceList.currency,
                                thousandsSeparator: savedConfig.priceList.thousands_separator,
                                fractionCount: 2,
                                fractionSeparator: savedConfig.priceList.decimal_separator,
                                symbolPosition: (savedConfig.priceList.currency_position == "right" ? "" : "front"),
                                symbolSpacing: true
                                })}}/{{ (product.min_quantity > 1) ? product.min_quantity : "" }} {{product.unit_type}}
                            </td>
                            <td v-show="savedConfig.priceList.show_prices == 1" class="text-right">
                                {{product.total | currency({
                                symbol: savedConfig.priceList.currency,
                                thousandsSeparator: savedConfig.priceList.thousands_separator,
                                fractionCount: 2,
                                fractionSeparator: savedConfig.priceList.decimal_separator,
                                symbolPosition: (savedConfig.priceList.currency_position == "right" ? "" : "front"),
                                symbolSpacing: true
                                })}}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <!-- TABLE MOBILE -->
                <table class="d-table d-lg-none" width="100%" :key="bomMobileKey">
                    <thead>
                        <tr style="border-bottom: 1px solid #ccc">
                            <th class="text-center">{{ $t('s4_bom_mobile_ref') }}</th>
                            <th class="text-center">{{ $t('s4_bom_mobile_quantity') }}</th>
                            <th v-show="savedConfig.priceList.show_prices == 1" class="text-center">{{ $t('s4_bom_mobile_price') }}</th>
                            <th v-show="savedConfig.priceList.show_prices == 1" class="text-center">{{ $t('s4_bom_mobile_total') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <savedConfigBomRowMobileComponent
                            v-for="(product,i) in savedConfig.BOM.products"
                            :key="i"
                            :product="product"
                            :configuration="savedConfig"
                        ></savedConfigBomRowMobileComponent>
                    </tbody>
                </table>

                <div v-show="savedConfig.priceList.show_prices == 1" class="mt-2 text-right">
                    <span class="text-center font-weight-bold mr-2">{{ $t('s4_Total') }}</span>
                    <span>
                        {{ savedConfig.BOM.total | currency({
                        symbol: savedConfig.priceList.currency,
                        thousandsSeparator: savedConfig.priceList.thousands_separator,
                        fractionCount: 2,
                        fractionSeparator: savedConfig.priceList.decimal_separator,
                        symbolPosition: (savedConfig.priceList.currency_position == "right" ? "" : "front"),
                        symbolSpacing: true
                        })}}
                    </span>
                </div>

            </div>
        </div>
    </div>
</template>


<style scoped lang="scss">
</style>

<script>
import { Fragment } from "vue-fragment";
import { app } from "../../application.js";
import savedConfigBomRowMobileComponent from "./savedConfigBomRowMobile.vue";

export default {
    name: "savedConfigBomComponent",
    components: { Fragment, savedConfigBomRowMobileComponent },
    props: {
        savedConfig: new Object()
    },
    data() {
        return {
            app: app,
            bomMobileKey: 1,
            showBOM: false
        };
    },

    beforeUpdate() {
        // BUG: Fragment per permetre updates que elimin files
        this.bomMobileKey++;
    },

    methods: {}
};
</script>




